export default __webpack_public_path__ + "tutorial-1@3x.4f97cdf2.png";